import { render, staticRenderFns } from "./LivesSection.vue?vue&type=template&id=6a3bd652"
import script from "./LivesSection.vue?vue&type=script&lang=js"
export * from "./LivesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports